/**
 * Maps app routes to help article slugs (see `help_articles.slug` in DB).
 * Fallback: general welcome article.
 */

export const DEFAULT_HELP_SLUG = 'erste-schritte-willkommen';

const PREFIX_RULES: { test: RegExp; slug: string }[] = [
  { test: /^\/campaigns\/[^/]+$/, slug: 'kampagnen-inhalte' },
  { test: /^\/suppliers\/[^/]+$/, slug: 'zulieferer-partner' },
  { test: /^\/activities\/[^/]+$/, slug: 'aktivitaeten-erstellen-status' },
  { test: /^\/composer\/[^/]+$/, slug: 'social-composer-kanaltabs' },
];

const EXACT: Record<string, string> = {
  '/dashboard': 'command-center',
  '/profile': 'profil-konto',
  '/marketing-plan': 'marketing-plan-anlegen',
  '/marketing-strategy': 'marketing-strategie-arbeiten',
  '/activities': 'aktivitaeten-erstellen-status',
  '/activities/calendar': 'social-calendar',
  '/marketing-calendar': 'social-calendar',
  '/calendar': 'social-calendar',
  '/campaigns': 'kampagnen-inhalte',
  '/statistics': 'statistiken-auswertungen',
  '/teams': 'teams-zusammenarbeit',
  '/suppliers': 'zulieferer-partner',
  '/documents': 'dokumente-verwaltung',
  '/notifications': 'benachrichtigungen-posteingang',
  '/onboarding': 'onboarding-einstieg',
  '/automation': 'social-automation',
  '/ai': 'companion-ki-assistent',
  '/companion': 'companion-ki-assistent',
  '/composer': 'social-composer-kanaltabs',
  '/planner': 'content-planner',
  '/social': 'social-hub',
  '/social/accounts': 'social-connect-accounts',
  '/social/queue': 'social-queue-fehler',
  '/media': 'social-media-library',
  '/help': DEFAULT_HELP_SLUG,
  '/admin/users': 'administration-benutzer-rollen',
  '/admin/roles': 'administration-benutzer-rollen',
  '/admin/integrations': 'integrationen',
  '/admin/settings': 'administration-benutzer-rollen',
  '/admin/notifications': 'admin-benachrichtigungen-center',
};

export function getHelpSlugForPath(path: string): string {
  const normalized = path.split('?')[0] || '/';
  const exact = EXACT[normalized];
  if (exact) return exact;
  for (const rule of PREFIX_RULES) {
    if (rule.test.test(normalized)) return rule.slug;
  }
  return DEFAULT_HELP_SLUG;
}

/** Hash navigation path for opening Help with preselected article. */
export function getHelpHashWithArticle(slug: string): string {
  return `/help?article=${encodeURIComponent(slug)}`;
}

export function getHelpTitleHint(path: string): string {
  const slug = getHelpSlugForPath(path);
  const labels: Record<string, string> = {
    'erste-schritte-dashboard': 'Dashboard & Übersicht',
    'command-center': 'Command Center',
    'profil-konto': 'Profil & Konto',
    'marketing-plan-anlegen': 'Marketingplan',
    'marketing-strategie-arbeiten': 'Marketingstrategie & Research',
    'aktivitaeten-erstellen-status': 'Aktivitäten',
    'marketing-kalender': 'Marketing-Kalender',
    'social-calendar': 'Content-Kalender',
    'kampagnen-inhalte': 'Kampagnen',
    'statistiken-auswertungen': 'Statistiken',
    'teams-zusammenarbeit': 'Teams',
    'zulieferer-partner': 'Zulieferer & Co-Marketing',
    'dokumente-verwaltung': 'Dokumente',
    'benachrichtigungen-posteingang': 'Benachrichtigungen (Posteingang)',
    'onboarding-einstieg': 'Onboarding',
    'automation-workflows': 'Automatisierung',
    'social-automation': 'Social Automation',
    'companion-ki-assistent': 'Companion / KI',
    'social-composer': 'Composer',
    'social-hub': 'Social Hub',
    'social-connect-accounts': 'Social-Konten verbinden',
    'social-media-library': 'Medienbibliothek',
    'administration-benutzer-rollen': 'Administration',
    'integrationen': 'Integrationen',
    'admin-benachrichtigungen-center': 'Benachrichtigungen',
  };
  return labels[slug] ?? 'Hilfe';
}
